document.addEventListener('DOMContentLoaded', function() {
    var playIcons = document.querySelectorAll('.play-icon');
    var closeIcons = document.querySelectorAll('.close-icon');

    playIcons.forEach(function(playIcon) {
        playIcon.addEventListener('click', function() {
            var videoPopup = this.nextElementSibling;
            videoPopup.style.display = 'block';
        });
    });

    closeIcons.forEach(function(closeIcon) {
        closeIcon.addEventListener('click', function() {
            var videoPopup = this.parentElement;
            videoPopup.style.display = 'none';
        });
    });
});
